import script from "./FilterItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterItem.vue?vue&type=script&setup=true&lang=js"

import "./FilterItem.vue?vue&type=style&index=0&id=4c5d45a3&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\git\\CatalogOnVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c5d45a3"]])

export default __exports__